<template>
	<div class="user_data_warp">
		<!-- tabs按钮 -->
		<el-tabs v-model="activeName" type="card">
			<el-tab-pane label="用户概括" name="first"></el-tab-pane>
			<!-- <el-tab-pane label="会员概括" name="second"></el-tab-pane> -->
		</el-tabs>
		<!-- tabs内容 -->
		<div class="tabs_con">
			<!--  用户概括container -->
			<div class="user_content" v-if="activeName=='first'">
				<!-- 1.用户概括 -->
				<div class="user_warp">
					<div class="user_title_row">用户概括</div>
					<!-- 1.1用户概括---card -->
					<div class="card_warp">
						<div class="user_card">
							<span>总用户数</span>
							<span>{{ data.userTotal?data.userTotal :0 }}</span>
							<span>
								较前一月
								{{ data.lastMonthAddTotal?(((data.nowMonthAddTotal / data.lastMonthAddTotal)-1)*100).toFixed(5) :0 }}%
							</span>
						</div>
						<div class="user_card">
							<span>今日新增用户数</span>
							<span>{{ data.userAddCount?data.userAddCount :0 }}</span>
							<span>
								较前一天
								{{ data.userAddCount?(((data.userAddCount / data.beforeUserAdd)-1)*100).toFixed(5) :0 }}%
							</span>
						</div>
						<div class="user_card">
							<span>今日访问用户数</span>
							<span>{{ data.todayLoginCount }}</span>
							<!-- <span>
                较前一天
                <i class="iconfont icon-shangjiantou-"></i>30%
              </span> -->
						</div>
						<div class="user_card">
							<span>今日活跃老用户数</span>
							<span>{{ data.todayOldUserCount }}</span>
							<!-- <span>
                较前一天
                <i class="iconfont icon-shangjiantou-"></i>30%
              </span> -->
						</div>
					</div>
				</div>
				<!-- 2.性别分布 -->
				<el-card class="new_and_old_warp">
					<div class="user_title_row">性别分布</div>
					<div class="work_row">
						<!-- 选择用户 -->
						<el-select v-model="sexUserType" size="small">
							<el-option v-for="item in labels" :key="item.id" :label="item.labelName"
								:value="item.id"></el-option>
						</el-select>
						<!-- 选择大概时间 -->
						<el-select class="ite" size="small" v-model="sexDateType" placeholder="请选择">
							<el-option v-for="item in user_date_list" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<!-- 选择时间 -->
						<el-time-select size="small" class="ite" v-model="timeVal" :picker-options="{
                start: '08:30',
                step: '00:15',
                end: '24:00'
              }" placeholder="选择时间"></el-time-select>
						<!-- 导出 -->
						<el-button class="ite" type="primary" size="small">导出</el-button>
					</div>
					<div class="data_warp">
						<!-- 环形图表 -->
						<div class="data_item">
							<ve-ring :judge-width="true" height="260px" width="90%" :data="typeData"
								legend-position="right" :extend="typeExted" :settings="typeSettings"
								:colors="ringColor"></ve-ring>
						</div>
						<span></span>
						<!-- 男女数量统计 -->
						<div class="data_item">
							<el-row>
								<el-col :span="6">性别</el-col>
								<el-col :span="6">用户数</el-col>
								<el-col :span="6">占比</el-col>
							</el-row>
							<div class="info_warp">
								<el-row>
									<el-col :span="6">男</el-col>
									<el-col :span="6">{{ data.userMaleCount }}</el-col>
									<el-col
										:span="6">{{ ((data.userMaleCount / data.userTotal)* 100).toFixed(4)   }}%</el-col>
								</el-row>
								<el-row>
									<el-col :span="6">女</el-col>
									<el-col :span="6">{{ data.userFemaleCount }}</el-col>
									<el-col
										:span="6">{{ ((data.userFemaleCount / data.userTotal) * 100).toFixed(4) }}%</el-col>
								</el-row>
							</div>
						</div>
					</div>
				</el-card>
				<!-- 3.年龄分布 -->
				<el-card class="new_and_old_warp">
					<div class="user_title_row">年龄分布</div>
					<div class="work_row">
						<!-- 选择用户 -->
						<el-select v-model="ageOps_val" size="small">
							<el-option v-for="item in labels" :key="item.id" :label="item.labelName"
								:value="item.id"></el-option>
						</el-select>
						<!-- 选择大概时间 -->
						<el-select size="small" class="ite" v-model="ageOps_val1" placeholder="请选择">
							<el-option v-for="item in user_date_list" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<!-- 选择时间 -->
						<el-time-select size="small" class="ite" v-model="ageTimeVal" :picker-options="{
                start: '08:30',
                step: '00:15',
                end: '24:00'
              }" placeholder="选择时间"></el-time-select>
						<!-- 导出 -->
						<el-button class="ite" type="primary" size="small">导出</el-button>
					</div>
					<div class="data_warp">
						<!-- 环形图表 -->
						<div class="data_item">
							<ve-ring :judge-width="true" height="260px" :data="ageData" legend-position="left"
								:extend="ageExted" :settings="typeSettings" :colors="ageColor"></ve-ring>
						</div>
						<span></span>
						<!-- 年龄段数量统计 -->
						<div class="data_item">
							<el-row>
								<el-col :span="6">年龄</el-col>
								<el-col :span="6">用户数</el-col>
								<el-col :span="6">占比</el-col>
							</el-row>
							<div class="age_info_warp">
								<el-row v-for="item in ageData.rows" :key="item.value" :label="item.age"
									:value="item.count">
									<el-col :span="6">{{ item.age }}</el-col>
									<el-col :span="6">{{ item.count }}</el-col>
									<el-col :span="6">{{ ((item.count / data.userTotal)* 100).toFixed(4)   }}%</el-col>
								</el-row>
							</div>
						</div>
					</div>
				</el-card>
				<!-- 4.新老客户交易构成 -->
				<!-- <el-card class="new_and_old_warp">
          <div class="user_title_row">新老客户交易构成</div>
          <div class="work_row">
            <el-select class="ite" v-model="no_val1" placeholder="请选择" size="small">
              <el-option
                v-for="item in user_date_list"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-time-select
			        size="small"
              class="ite"
              v-model="noTimeVal"
              :picker-options="{
                start: '08:30',
                step: '00:15',
                end: '24:00'
              }"
              placeholder="选择时间"
            ></el-time-select>
            <el-button class="ite" type="primary" size="small">导出</el-button>
          </div>
          <div class="data_warp">
            <div class="data_item" style="width: 70%">
              <ve-ring
                :judge-width="true"
                height="260px"
                :data="noData"
                :extend="noExted"
                :settings="noSettings"
                :colors="noColor"
              ></ve-ring>
            </div>
            <div class="data_item">
              <el-row class="row_title">
                <el-col :span="12">
                  <span class="left"></span>新客户
                </el-col>
                <el-col :span="12">
                  <span class="right"></span>老客户
                </el-col>
              </el-row>
              <div class="no_info_warp">
                <el-row>
                  <el-col :span="4"></el-col>
                  <el-col :span="5">付款金额</el-col>
                  <el-col :span="5">较前一个月</el-col>
                  <el-col :span="5">付款人数</el-col>
                  <el-col :span="5">较前一个月</el-col>
                </el-row>
                <el-row>
                  <el-col :span="4">新客户</el-col>
                  <el-col :span="5">￥1970700.49</el-col>
                  <el-col :span="5">↑ 4.73%</el-col>
                  <el-col :span="5">30</el-col>
                  <el-col :span="5">↓ -92.00%</el-col>
                </el-row>
                <el-row>
                  <el-col :span="4">老客户</el-col>
                  <el-col :span="5">￥0.00</el-col>
                  <el-col :span="5">/</el-col>
                  <el-col :span="5">42</el-col>
                  <el-col :span="5">↑ 2000%</el-col>
                </el-row>
              </div>
            </div>
          </div>
        </el-card> -->
				<!-- 5.用户偏好 -->
				<!-- <el-card class="new_and_old_warp">
          <div class="user_title_row">用户偏好</div>
          <div class="work_row">
            <el-select v-model="user_val" size="small">
              <el-option
                v-for="item in labels"
                :key="item.id"
                :label="item.labelName"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-select size="small" class="ite" v-model="user_val1" placeholder="请选择">
              <el-option
                v-for="item in user_date_list"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-time-select
			        size="small"
              class="ite"
              v-model="userTimeVal"
              :picker-options="{
                start: '08:30',
                step: '00:15',
                end: '24:00'
              }"
              placeholder="选择时间"
            ></el-time-select>
            <el-button class="ite" type="primary" size="small">导出</el-button>
          </div>
          <div class="charts_warp">
            <div class="charts_item">
              <ve-ring
                :judge-width="true"
                height="300px"
                :data="lsData"
                legend-position="left"
                :extend="lsExted"
                :settings="typeSettings"
                :colors="lsColor"
              ></ve-ring>
            </div>
            <div class="charts_item">
              <ve-ring
                :judge-width="true"
                height="300px"
                :data="stageData"
                legend-position="left"
                :extend="stageExted"
                :settings="typeSettings"
                :colors="stageColor"
              ></ve-ring>
            </div>
            <div class="charts_item">
              <ve-histogram
                :data="histData"
                :colors="histColor"
                :extend="histExtend"
                height="300px"
                :settings="histSettings"
              ></ve-histogram>
            </div>
          </div>
        </el-card> -->
				<!-- 6.用户评价 -->
				<!-- <el-card class="new_and_old_warp">
          <div class="user_title_row">用户评价</div>
          <div class="work_row">
            <el-select v-model="evl_val" size="small">
              <el-option
                v-for="item in labels"
                :key="item.id"
                :label="item.labelName"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-select class="ite" v-model="evl_val1" placeholder="请选择" size="small">
              <el-option
                v-for="item in user_date_list"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-time-select
			        size="small"
              class="ite"
              v-model="evlTimeVal"
              :picker-options="{
                start: '08:30',
                step: '00:15',
                end: '24:00'
              }"
              placeholder="选择时间"
            ></el-time-select>
            <el-button class="ite" type="primary" size="small">导出</el-button>
          </div>
          <div class="data_warp">
            <div class="data_item" style="width: 70%">
              <ve-ring
                :judge-width="true"
                height="260px"
                :data="commentData"
                :extend="evlExted"
                legend-position="left"
                :settings="typeSettings"
                :colors="evlColor"
              ></ve-ring>
            </div>
            <div class="data_item">
              <div class="no_info_warp">
                <el-row>
                  <el-col :span="6"></el-col>
                  <el-col :span="6">非常满意</el-col>
                  <el-col :span="6">满意</el-col>
                  <el-col :span="6">一般</el-col>
                  <el-col :span="6">不满意</el-col>
                  <el-col :span="6">非常不满意</el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">新客户</el-col>
                  <el-col :span="6">{{ commentComputed(0, "非常满意") }}%</el-col>
                  <el-col :span="6">{{ commentComputed(0, "满意") }}%</el-col>
                  <el-col :span="6">{{ commentComputed(0, "一般") }}%</el-col>
                  <el-col :span="6">{{ commentComputed(0, "不满意") }}%</el-col>
                  <el-col :span="6">{{ commentComputed(0, "非常不满意") }}%</el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">老客户</el-col>
                  <el-col :span="6">{{ commentComputed(1, "非常满意") }}%</el-col>
                  <el-col :span="6">{{ commentComputed(1, "满意") }}%</el-col>
                  <el-col :span="6">{{ commentComputed(1, "一般") }}%</el-col>
                  <el-col :span="6">{{ commentComputed(1, "不满意") }}%</el-col>
                  <el-col :span="6">{{ commentComputed(1, "非常不满意") }}%</el-col>
                </el-row>
              </div>
            </div>
          </div>
        </el-card> -->
				<!-- 7.对于潮剪，用户所关注 -->
				<!-- <el-card class="new_and_old_warp">
          <div class="user_title_row">对于潮剪，用户所关注</div>
          <div class="work_row">
            <el-select v-model="follow_val" size="small">
              <el-option
                v-for="item in labels"
                :key="item.id"
                :label="item.labelName"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-select class="ite" v-model="follow_val1" placeholder="请选择" size="small">
              <el-option
                v-for="item in user_date_list"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-time-select
			        size="small"
              class="ite"
              v-model="followTimeVal"
              :picker-options="{
                start: '08:30',
                step: '00:15',
                end: '24:00'
              }"
              placeholder="选择时间"
            ></el-time-select>
            <el-button class="ite" type="primary" size="small">导出</el-button>
          </div>
          <div class="data_warp">
            <div class="data_item" style="width: 70%">
              <ve-ring
                :judge-width="true"
                height="300px"
                :data="followData"
                :extend="followExted"
                legend-position="left"
                :settings="typeSettings"
                :colors="followColor"
              ></ve-ring>
            </div>
            <div class="data_item">
              <div class="follow_info_warp">
                <el-row>
                  <el-col :span="6"></el-col>
                  <el-col :span="6">发型师形象</el-col>
                  <el-col :span="6">店铺的整洁</el-col>
                  <el-col :span="6">理发技术</el-col>
                  <el-col :span="6">价格与优惠</el-col>
                  <el-col :span="6">有趣的活动</el-col>
                  <el-col :span="6">其他</el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">17岁以下</el-col>
                  <el-col :span="6">{{ followComputed("发型师形象", "17岁以下") }}</el-col>
                  <el-col :span="6">{{ followComputed("店铺的整洁", "17岁以下") }}</el-col>
                  <el-col :span="6">{{ followComputed("理发技术", "17岁以下") }}</el-col>
                  <el-col :span="6">{{ followComputed("价格与优惠", "17岁以下") }}</el-col>
                  <el-col :span="6">{{ followComputed("有趣的活动", "17岁以下") }}</el-col>
                  <el-col :span="6">{{ followComputed("其他", "17岁以下") }}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">18-24岁</el-col>
                  <el-col :span="6">{{ followComputed("发型师形象", "18-24岁") }}</el-col>
                  <el-col :span="6">{{ followComputed("店铺的整洁", "18-24岁") }}</el-col>
                  <el-col :span="6">{{ followComputed("理发技术", "18-24岁") }}</el-col>
                  <el-col :span="6">{{ followComputed("价格与优惠", "18-24岁") }}</el-col>
                  <el-col :span="6">{{ followComputed("有趣的活动", "18-24岁") }}</el-col>
                  <el-col :span="6">{{ followComputed("其他", "18-24岁") }}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">25-29岁</el-col>
                  <el-col :span="6">{{ followComputed("发型师形象", "25-29岁") }}</el-col>
                  <el-col :span="6">{{ followComputed("店铺的整洁", "25-29岁") }}</el-col>
                  <el-col :span="6">{{ followComputed("理发技术", "25-29岁") }}</el-col>
                  <el-col :span="6">{{ followComputed("价格与优惠", "25-29岁") }}</el-col>
                  <el-col :span="6">{{ followComputed("有趣的活动", "25-29岁") }}</el-col>
                  <el-col :span="6">{{ followComputed("其他", "25-29岁") }}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">30-39岁</el-col>
                  <el-col :span="6">{{ followComputed("发型师形象", "30-39岁") }}</el-col>
                  <el-col :span="6">{{ followComputed("店铺的整洁", "30-39岁") }}</el-col>
                  <el-col :span="6">{{ followComputed("理发技术", "30-39岁") }}</el-col>
                  <el-col :span="6">{{ followComputed("价格与优惠", "30-39岁") }}</el-col>
                  <el-col :span="6">{{ followComputed("有趣的活动", "30-39岁") }}</el-col>
                  <el-col :span="6">{{ followComputed("其他", "30-39岁") }}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">40-49岁</el-col>
                  <el-col :span="6">{{ followComputed("发型师形象", "40-49岁") }}</el-col>
                  <el-col :span="6">{{ followComputed("店铺的整洁", "40-49岁") }}</el-col>
                  <el-col :span="6">{{ followComputed("理发技术", "40-49岁") }}</el-col>
                  <el-col :span="6">{{ followComputed("价格与优惠", "40-49岁") }}</el-col>
                  <el-col :span="6">{{ followComputed("有趣的活动", "40-49岁") }}</el-col>
                  <el-col :span="6">{{ followComputed("其他", "40-49岁") }}</el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">50岁以上</el-col>
                  <el-col :span="6">{{ followComputed("发型师形象", "50岁以上") }}</el-col>
                  <el-col :span="6">{{ followComputed("店铺的整洁", "50岁以上") }}</el-col>
                  <el-col :span="6">{{ followComputed("理发技术", "50岁以上") }}</el-col>
                  <el-col :span="6">{{ followComputed("价格与优惠", "50岁以上") }}</el-col>
                  <el-col :span="6">{{ followComputed("有趣的活动", "50岁以上") }}</el-col>
                  <el-col :span="6">{{ followComputed("其他", "50岁以上") }}</el-col>
                </el-row>
              </div>
            </div>
          </div>
        </el-card> -->
			</div>
			<!-- 会员概括container -->
			<div class="vip_content" v-else>
				<Hairs></Hairs>
			</div>
		</div>
	</div>
</template>
<script>
	import Hairs from "./hair3.vue"
	export default {
		components: {
			Hairs
		},
		data() {
			this.typeSettings = {
				radius: [70, 90],
				offsetY: 130,
				label: {
					normal: {
						show: false,
					},
				},
			};
			this.noSettings = {
				radius: [0, 90],
				offsetY: 130,
				legendLimit: 0,
			};
			this.histSettings = {};
			return {
				loading: true,
				activeName: "first",
				// tabs 数据列表
				tabs: [{
					id: 0,
					value: "用户概括",
					isActive: true,
				}, {
					id: 1,
					value: "会员概括",
					isActive: false,
				}, ],
				data: {},
				sexData: {},
				// 数据查询-条件过滤-用户类型
				user_type_list: [{
					value: 1,
					label: "全部用户",
				}, {
					value: 2,
					label: "活跃用户",
				}, {
					value: 3,
					label: "老用户",
				}, {
					value: 4,
					label: "新增用户",
				}],
				// 数据查询-条件过滤-时间范围
				user_date_list: [{
					value: 1,
					label: "昨天",
				}, {
					value: 2,
					label: "最近七天",
				}, {
					value: 3,
					label: "最近30天",
				}, {
					value: 4,
					label: "自定义",
				}],
				// 时间范围？？？
				timeVal: "",
				ageTimeVal: "",
				noTimeVal: "",
				userTimeVal: "",
				evlTimeVal: "",
				followTimeVal: "",
				// 性别统计下拉框数据-用户类型
				sexUserType: 0,
				// 性别统计下拉框数据-时间范围
				sexDateType: 1,
				// 年龄统计下拉框数据-用户类型
				ageOps_val: 0,
				// 年龄统计下拉框数据-时间范围
				ageOps_val1: 1,
				// 新老用户统计下拉框数据-用户类型
				no_val: 0,
				// 新老用户统计下拉框数据-时间范围
				no_val1: 1,
				// 偏好统计下拉框数据-用户类型
				user_val: 0,
				// 偏好统计下拉框数据-时间范围
				user_val1: 1,
				// 评价统计下拉框数据-用户类型
				evl_val: 0,
				// 评价统计下拉框数据-时间范围
				evl_val1: 1,
				// 关注统计下拉框数据-用户类型
				follow_val: 0,
				// 关注统计下拉框数据-时间范围
				follow_val1: 1,
				// ---------------图表数据------------------
				// 第一栏图表
				// 新老客户交易构成环形图表数据
				typeData: {
					columns: ["sex", "count"],
					rows: [{
						sex: "男",
						count: 0
					}, {
						sex: "女",
						count: 0
					}, {
						sex: "未知",
						count: 0
					}, ],
				},
				ringColor: ["#409EFF", "#FB697E", "#C4B4E4"],
				typeExted: {
					series: {
						center: ["40%", "50%"],
					},
					legend: {
						right: 0,
						icon: "circle",
						itemWidth: 10,
						itemHeight: 10,
						itemGap: 20,
					},
				},
				// 第二栏图表
				// 年龄分布环形图表数据
				ageData: {
					columns: ["age", "count"],
					rows: [{
						age: "17岁以下",
						count: 0
					}, {
						age: "18岁-24岁",
						count: 0
					}, {
						age: "25岁-29岁",
						count: 0
					}, {
						age: "30岁-39岁",
						count: 0
					}, {
						age: "40岁-49岁",
						count: 0
					}, {
						age: "50岁以上",
						count: 0
					}, {
						age: "未知",
						count: 0
					}, ],
				},
				ageColor: [
					"#409EFF",
					"#FFA340",
					"#2CDDCC",
					"#FF7C40",
					"#FB697E",
					"#845FFC",
					"#C4B4E4"
				],
				ageExted: {
					series: {
						center: ["40%", "50%"],
					},
					legend: {
						left: 0,
						icon: "circle",
						itemWidth: 10,
						itemHeight: 10,
						itemGap: 15,
					},
				},
				// 第三栏图表
				// 新老客户交易构成扇形图表数据
				noData: {
					columns: ["first", "count"],
					rows: [{
						first: "老客户",
						count: 1530
					}, {
						first: "新客户",
						count: 2393
					}, ],
				},
				noColor: ["#845FFD", "#FB697E"],
				noExted: {
					series: {
						center: ["40%", "50%"],
					},
				},
				// 第四栏图表
				// 用户偏好第一个图表数据
				lsData: {
					columns: ["hairstyle", "count"],
					rows: [{
						hairstyle: "短发",
						count: 0
					}, {
						hairstyle: "长发",
						count: 0
					}, {
						hairstyle: "未知",
						count: 0
					}, ],
				},
				lsColor: ["#FFA340", "#2CDDCC", "#C4B4E4"],
				lsExted: {
					series: {
						center: ["50%", "50%"],
					},
					legend: {
						left: 0,
						icon: "circle",
						itemWidth: 10,
						itemHeight: 10,
						itemGap: 20,
					},
				},
				// 用户偏好第二个图表数据
				stageData: {
					columns: ["hey", "count"],
					rows: [{
						hey: "20-25天",
						count: 0
					}, {
						hey: "30-40天",
						count: 0
					}, {
						hey: "80-90天",
						count: 0
					}, {
						hey: "其他",
						count: 0
					}, {
						hey: "未知",
						count: 0
					}, ],
				},
				stageColor: ["#FFA340", "#2CDDCC", "#FB697E", "#845FFC", "#C4B4E4"],
				stageExted: {
					series: {
						center: ["60%", "50%"],
					},
					legend: {
						left: 0,
						icon: "circle",
						itemWidth: 10,
						itemHeight: 10,
						itemGap: 20,
					},
				},
				// 用户偏好第三个图表数据
				histData: {
					columns: ["career", "count"],
					rows: [{
						career: "周边工薪族",
						count: 0
					}, {
						career: "街坊邻里",
						count: 0
					}, {
						career: "学生",
						count: 0
					}, {
						career: "尊贵长辈",
						count: 0
					}, {
						career: "带娃出行",
						count: 0
					}, {
						career: "其他",
						count: 0
					}, ],
				},
				histColor: ["#FFA340"],
				histExtend: {
					xAxis: {
						axisLabel: {
							interval: 0,
						},
					},
					series: {
						name: "",
						barWidth: 30,
						label: {
							show: true,
							position: "outside",
						},
					},
				},
				// 第五栏图表
				// 用户评价图表数据
				commentData: {
					columns: ["remark", "count"],
					rows: [{
							remark: "非常满意",
							count: 0
						}, {
							remark: "满意",
							count: 0
						}, {
							remark: "一般",
							count: 0
						}, {
							remark: "不满意",
							count: 0
						},
						{
							remark: "非常不满意",
							count: 0
						},
					],
				},
				evlColor: ["#FFA340", "#409EFF", "#FF7C40", "#FB697E", "#845FFC"],
				evlExted: {
					series: {
						center: ["40%", "50%"],
					},
					legend: {
						left: 0,
						icon: "circle",
						itemWidth: 10,
						itemHeight: 10,
						itemGap: 20,
					},
				},
				// 第六栏图表
				// 对于潮剪，用户所关注图表数据
				followData: {
					columns: ["follow", "count"],
					rows: [{
						follow: "发型师形象",
						count: 0
					}, {
						follow: "店铺的整洁",
						count: 0
					}, {
						follow: "理发技术",
						count: 0
					}, {
						follow: "价格与优惠",
						count: 0
					}, {
						follow: "有趣的活动",
						count: 0
					}, {
						follow: "其他",
						count: 0
					}, {
						follow: "未知",
						count: 0
					}, ],
				},
				followColor: [
					"#FFA340",
					"#409EFF",
					"#FF7C40",
					"#FB697E",
					"#845FFC",
					"#2CDDCC",
					"#C4B4E4"
				],
				followExted: {
					series: {
						center: ["45%", "50%"],
					},
					legend: {
						left: 0,
						icon: "circle",
						itemWidth: 10,
						itemHeight: 10,
						itemGap: 20,
					},
				},
				labels: [{
					labelName: "全部用户",
					id: 0
				}],
			};
		},
		computed: {
			followComputed() {
				return (remark, age) => {
					var count = 0;
					this.data.juvenileFollow.forEach(follow => {
						if (follow.remark == remark) {
							follow.data.forEach(data => {
								if (data.remark == age) return count = data.count
							})
						}
					})
					return count;
				}
			},
			commentComputed() {
				return (userType, remark) => {
					let info = 0;
					this.data.commentCount[userType].data.forEach(comment => {
						if (comment.remark == remark) info = ((comment.count / this.data.commentTotal) * 100)
							.toFixed(4)
					})
					return info;
				}
			}
		},
		methods: {
			// tabs切换点击事件
			tabsSwitch(id) {
				this.tabs.forEach((v, i) =>
					i === id ? (v.isActive = true) : (v.isActive = false)
				);
			},
			// 获取用户量数据 优先执行后在查询其他数据
			getUserData() {
				this.$http.post("data/main").then(res => {
					this.data = res.body.data;
					this.getSexData();
				})
			},
			getSexData() {
				this.$http.post("data/sex").then(res => {
					this.sexData = res.body.data
				})
			},
			// 获取用户对潮剪的关注
			getUserFollow() {
				this.$http.post("data/follow").then(res => {

				})
			},
			getLabel() {
				this.$http.get("dUserLabel/list").then(res => {
					this.labels.push(...res.body.data)
				})
			},
		},
		mounted() {
			this.getUserData();
			// this.getLabel();
		},
	};
</script>
<style lang="less" scoped>
	.user_title_row {
		line-height: 50px;
		color: #3e3e3e;
		font-size: 16px;
		padding-left: 14px;
		position: relative;
		font-weight: bold;

		&:before {
			content: "";
			position: absolute;
			left: 0;
			width: 5px;
			height: 15px;
			background: #409eff;
			border-radius: 2px;
			top: 50%;
			transform: translateY(-50%);
		}
	}

	.user_data_warp {
		.tabs_row {
			border: 1px solid #ececec;
			background-color: #f2f2f2;
			display: flex;
			line-height: 56px;
			font-size: 16px;

			.tabs_item {
				width: 140px;
				text-align: center;
				color: #3e3e3e;
				font-weight: 400;
				cursor: pointer;

				&:hover {
					color: #409eff;
				}
			}

			.tabs_active {
				background-color: #fff;
				color: #409eff;
			}
		}

		.tabs_con {
			.user_content {
				.user_warp {
					padding-bottom: 35px;

					.card_warp {
						display: flex;
						justify-content: space-around;

						.user_card {
							background-color: #f2f2f2;
							width: 22%;
							height: 165px;
							border-radius: 6px;
							padding: 20px;
							box-sizing: border-box;
							display: flex;
							flex-direction: column;
							justify-content: space-between;

							span {
								font-weight: 400;
								color: #3e3e3e;
								font-size: 16px;

								&:nth-of-type(2) {
									font-size: 40px;
								}

								i {
									font-weight: bold;
									font-size: 18px;
								}
							}
						}
					}
				}

				.new_and_old_warp {
					padding: 0 20px;
					margin-bottom: 20px;

					.work_row {
						height: 32px;
						margin-bottom: 14px;
						display: flex;

						.el-select {
							width: 110px;
						}

						.ite {
							margin-left: 20px;
						}
					}

					.data_warp {
						display: flex;
						justify-content: space-between;
						margin-bottom: 20px;
						box-sizing: border-box;

						>span {
							position: relative;

							&:before {
								content: "";
								position: absolute;
								top: 50%;
								transform: translateY(-50%);
								width: 2px;
								height: 160px;
								background: #e0e0e0;
							}
						}

						.data_item {
							width: 100%;

							.el-row {
								display: flex;
								justify-content: center;
								color: #9a9a9a;
								font-size: 18px;
								font-weight: 400;

								.el-col {
									text-align: center;
								}
							}

							.row_title {
								color: #3e3e3e;
								font-size: 16px;
								font-weight: 400;

								.el-col {
									display: flex;
									justify-content: center;
									align-items: center;

									>span {
										display: block;
										width: 10px;
										height: 10px;
										border-radius: 50%;
										margin-right: 10px;
									}

									.left {
										background: #fb697e;
									}

									.right {
										background: #845ffd;
									}
								}
							}

							.info_warp {
								margin-top: 25px;
								height: 160px;
								display: flex;
								flex-direction: column;
								justify-content: space-around;

								>.el-row {
									display: flex;
									justify-content: center;
									font-size: 16px;
									color: #3e3e3e;

									.el-col {
										text-align: center;
									}
								}
							}

							.age_info_warp {
								margin-top: 25px;

								>.el-row {
									font-size: 16px;
									color: #3e3e3e;

									.el-col {
										text-align: center;
										line-height: 30px;
									}
								}
							}

							.no_info_warp {
								margin-top: 25px;

								.el-row {
									border: 1px solid #ececec;

									&:first-of-type {
										background: #f7f7f7;
									}

									&:nth-last-child(-n + 2) {
										border-top: 0;
									}

									.el-col {
										color: #7a7a7a;
										font-size: 16px;
										border-right: 1px solid #ececec;
										padding: 20px 0;

										&:last-of-type {
											border-right: 0;
										}
									}
								}
							}

							.follow_info_warp {
								margin-top: 25px;

								.el-row {
									border: 1px solid #ececec;
									border-top: 0;

									&:first-of-type {
										background: #f7f7f7;
										border-top: 1px solid #ececec;

										>.el-col {
											padding: 20px 0;
										}
									}

									.el-col {
										color: #7a7a7a;
										font-size: 16px;
										border-right: 1px solid #ececec;
										padding: 5px 0;

										&:last-of-type {
											border-right: 0;
										}
									}
								}
							}
						}
					}

					.charts_warp {
						display: flex;

						.charts_item {
							width: 30%;

							&:last-of-type {
								width: 40%;
							}
						}
					}
				}
			}
		}
	}
</style>